export default __webpack_public_path__ + "static/media/stars.9bf5048e.svg";